import { createFileRoute } from "@tanstack/react-router";
import ContactPage from "@/pages/ContactPage";
import { pageHead } from "@/lib/site";

export const Route = createFileRoute("/contact")({
  head: () =>
    pageHead(
      "Contact Scotty's Land Specialist | Highland, Utah",
      "Contact Scotty's Land Specialist in Highland, Utah for land clearing, dumpster rental, cleanup, and snow removal. Call (801) 400-3346.",
      "/contact",
    ),
  component: ContactPage,
});
